import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=7c8055c7&scoped=true&"
var script = {}
import style0 from "../../assets/css/relate.css?vue&type=style&index=0&id=7c8055c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8055c7",
  null
  
)

export default component.exports